/**
 * @fileoverview Input/output schemas for world-organization-ideation-v3.
 *
 * This agent generates ideas for organizations (factions, nations, institutions).
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { WorldOrganizationIdeaV3Schema, WorldOrganizationElementEnum } from '@/domains/world-building/schemas';

export const InputSchema = z.object({
  ...BaseFlowInputSchema.shape,
  ...AGENT_SCHEMA_OBJECTS.storyContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.loreContext.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.worldElements.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.worldOrganizations.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.characters.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.initialChapterContent.schema.shape,
  ...AGENT_SCHEMA_OBJECTS.userMessage.schema.shape,
  targetElement: WorldOrganizationElementEnum.optional().describe(
    'Optional filter to generate only a specific element type (faction, nation, or institution). If not provided, generates a mix.'
  ),
});

export type Input = z.infer<typeof InputSchema>;

const WorldOrganizationIdeaOutputSchema = WorldOrganizationIdeaV3Schema.omit({
  tempId: true,
  source: true,
});

export const OutputSchema = z.object({
  organizations: z.array(WorldOrganizationIdeaOutputSchema).describe('An array of generated world organization ideas.'),
});

export type Output = z.infer<typeof OutputSchema>;
